import React from 'react'
import './hearerTop.css'

function HeaderTop() {
  return (
    <div className='headerTop'>
         <div className="navbar-top style-3">
         <div className="container">
            <div className="row">
               <div className="col-lg-6 col-md-6 align-self-center">
                  <ul className="topbar-right text-md-start text-center">
                     <li><p><i className="far fa-clock"></i>ساعات العمل : يومياُ من 8:00 ص -- 11:00 م</p></li>
                  </ul>
               </div>
               <div className="col-lg-6 col-md-6  d-md-block">
                  <ul className="topbar-right text-md-end text-center d-flex align-items-center justify-content-center">
                  <li className=" d-lg-inline-block">
                    <p className='mt-1'><i className="fas fa-phone"></i><a href="tel:0552092001">0552092011</a></p>
                    </li>
                     <li>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
    </div>
  )
}

export default HeaderTop